import React, { useState } from "react";
import { usePagination } from "../../../hooks";
import { AdminSharedHeader, AdminSharedTable, AdminSharedDeleteModal } from "../Shared/";
import { useGetTargetVariablesQuery, useDeleteTargetVariableMutation } from "../services";
import { TargetVariableForm } from "./Form";
import { useDelete } from "../../../hooks";
import { Link } from "react-router-dom";

export const TargetVariablesContainer = () => {
  const { page, perPage, pagination } = usePagination();

  const {
    data = { data: [], total_count: 0 },
    isFetching,
    isSuccess,
    error,
  } = useGetTargetVariablesQuery({
    page,
    per_page: perPage,
    order_by: "created_at",
    order_dir: "desc",
  });

  const {
    deleteItem: deleteTargetVariable,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteTargetVariableMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const [idToEdit, setIdToEdit] = useState(null);
  const [idToDelete, setIdToDelete] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  const createNewHandler = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const editClickHandler = (datum) => {
    setShowForm(true);
    setIdToEdit(datum.id);
  };

  const deleteClickHandler = (datum) => {
    setShowDeleteWarning(true);
    setIdToDelete(datum.id);
  };

  const headers = [
    { label: "Name", key: "name", className: "name" },
    {
      label: "System Default",
      nestedValue: true,
      getNestedValue: ({ is_default }) => {
        return <>{is_default ? <span>Yes</span> : <span>No</span>}</>;
      },
      className: "system-default",
    },
    {
      label: "OBD Codes",
      nestedValue: true,
      className: "devices text-center",
      getNestedValue: ({ id, obd_codes_count, name }) => {
        return (
          <>
            {obd_codes_count > 0 ? (
              <Link
                to={`/superadmin/others/obd_codes?target_variable_id=${id}&name=${name}`}
                style={{ textDecoration: "none" }}
              >
                {obd_codes_count}
              </Link>
            ) : (
              <span>0</span>
            )}
          </>
        );
      },
    },
    { label: "Created on", key: "created_at" },
  ];

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data?.findIndex((datum) => datum.id === id);

    if (index > -1) {
      name = data?.data[index].name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container">
        <AdminSharedHeader
          createNewHandler={createNewHandler}
          groupName="other"
          heading="Configurations"
        />

        <AdminSharedTable
          isLoading={isFetching}
          error={error}
          isSuccess={isSuccess}
          data={data.data}
          headers={headers}
          pagination={{ ...pagination, count: data.total_count }}
          onEdit={editClickHandler}
          onDelete={deleteClickHandler}
          editDeleteCheck="is_default"
          auditResource="TargetVariable"
          auditKey="name"
          className="target-variables"
        />
      </article>

      {showForm && <TargetVariableForm idToEdit={idToEdit} closeForm={() => setShowForm(false)} />}

      <AdminSharedDeleteModal
        error={deleteErrorMsg}
        show={showDeleteWarning}
        resourceName="Target Variables"
        getDeleteItemName={() => getDeleteItemName(idToDelete)}
        onHide={() => {
          setDeleteErrorMsg("");
          setShowDeleteWarning(false);
        }}
        onDelete={() => deleteTargetVariable({ id: idToDelete })}
      />
    </>
  );
};
